import {Block, CanvasContext, CanvasID} from "./types";
import {Task} from "@traas/lib/src/api/dto/Task";

export function getBlocksInCanvas(context: CanvasContext, date: Date, teamId: string): Block<Task>[] {
  const canvasId = getCanvasId(date, teamId)
  return context.get(canvasId) ?? []
}

export function getCanvasId(date: Date, teamId: string): CanvasID {
  return `${teamId}:${date.getFullYear()}-${String(date.getMonth()+1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}

export function parseCanvasId(canvasId: CanvasID): {teamId: string, date: Date} {
  const [teamId, dateString] = canvasId.split(':')
  return {teamId, date: new Date(dateString)}
}

export function parseBufferDate(canvasId: CanvasID): Date {
  const dateString = canvasId.split('buffer-')[1]
  return new Date(dateString)
}
